/** Phone dial codes the profile offers: the code, a short label for the computer's menu, and the country's name. */
export const DIAL_CODES: { code: string; label: string; name: string }[] = [
  { code: "+1", label: "US", name: "United States" },
  { code: "+44", label: "UK", name: "United Kingdom" },
  { code: "+91", label: "IN", name: "India" },
  { code: "+61", label: "AU", name: "Australia" },
  { code: "+64", label: "NZ", name: "New Zealand" },
  { code: "+353", label: "IE", name: "Ireland" },
  { code: "+49", label: "DE", name: "Germany" },
  { code: "+33", label: "FR", name: "France" },
  { code: "+34", label: "ES", name: "Spain" },
  { code: "+39", label: "IT", name: "Italy" },
  { code: "+31", label: "NL", name: "Netherlands" },
  { code: "+41", label: "CH", name: "Switzerland" },
  { code: "+46", label: "SE", name: "Sweden" },
  { code: "+351", label: "PT", name: "Portugal" },
  { code: "+971", label: "AE", name: "United Arab Emirates" },
  { code: "+966", label: "SA", name: "Saudi Arabia" },
  { code: "+65", label: "SG", name: "Singapore" },
  { code: "+60", label: "MY", name: "Malaysia" },
  { code: "+62", label: "ID", name: "Indonesia" },
  { code: "+63", label: "PH", name: "Philippines" },
  { code: "+66", label: "TH", name: "Thailand" },
  { code: "+84", label: "VN", name: "Vietnam" },
  { code: "+81", label: "JP", name: "Japan" },
  { code: "+82", label: "KR", name: "South Korea" },
  { code: "+86", label: "CN", name: "China" },
  { code: "+852", label: "HK", name: "Hong Kong" },
  { code: "+55", label: "BR", name: "Brazil" },
  { code: "+52", label: "MX", name: "Mexico" },
  { code: "+27", label: "ZA", name: "South Africa" },
  { code: "+234", label: "NG", name: "Nigeria" },
  { code: "+254", label: "KE", name: "Kenya" },
  { code: "+20", label: "EG", name: "Egypt" },
  { code: "+972", label: "IL", name: "Israel" },
  { code: "+90", label: "TR", name: "Turkey" },
];

/** Countries for an address (value = ISO code, label = full name). */
export const COUNTRIES: { code: string; name: string }[] = [
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "IN", name: "India" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "IE", name: "Ireland" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "CH", name: "Switzerland" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "PT", name: "Portugal" },
  { code: "PL", name: "Poland" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SG", name: "Singapore" },
  { code: "MY", name: "Malaysia" },
  { code: "ID", name: "Indonesia" },
  { code: "PH", name: "Philippines" },
  { code: "TH", name: "Thailand" },
  { code: "VN", name: "Vietnam" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "CN", name: "China" },
  { code: "HK", name: "Hong Kong" },
  { code: "BR", name: "Brazil" },
  { code: "MX", name: "Mexico" },
  { code: "AR", name: "Argentina" },
  { code: "ZA", name: "South Africa" },
  { code: "NG", name: "Nigeria" },
  { code: "KE", name: "Kenya" },
  { code: "EG", name: "Egypt" },
  { code: "IL", name: "Israel" },
  { code: "TR", name: "Turkey" },
];
